module.exports = __webpack_public_path__ + "img/nav.72e9bad9.svg";